export default function getAccessRoleAndCalendarName(calendarsList, calendarId) {
    var filteredCalendars = calendarsList.filter(function (calendar) { return calendar.idCrypt === calendarId; });
    if (filteredCalendars.length > 0) {
        return {
            accessRole: filteredCalendars[0].accessRole,
            calendarName: filteredCalendars[0].name,
        };
    }
    return {};
}
//# sourceMappingURL=getAccessRoleAndCalendarName.js.map